/**
 * @owner @Appboy/core-objects
 */
export const customObjectsTypeNameExternalIdUsers = "/data_objects/:type_name/:external_id/users" as const;
